export let pageTopMenuFilter = [{
      label: '用户基本信息',
      value: 'basic-message'
    },
    {
      label: '积分记录',
      value: 'integral-record'
    },
    {
      label: '兑换记录',
      value: 'exchange-record'
    },
    {
      label: '生命银行订单',
      value: 'lifeBank-order'
    },
    {
      label: '生命银行样本',
      value: 'lifeBank-sample'
    },
    {
      label: '同步获取订单',
      value: 'operate-order'
    },
    {
      label: '生命银行里程碑',
      value: 'lifeBank-milestone'
    },
    //   {
    //     label: '家庭成员',
    //     value: 'family-members'
    //   },
    {
      label: '健康档案',
      value: 'health-record'
    },
    {
      label: '已邀请用户',
      value: 'user-of-invite'
    },
    {
      label: '钱包',
      value: 'wallet'
    },
    {
      label: '优惠劵',
      value: 'coupon'
    },
    {
      label: "发票",
      value: "invoice"
    }
  ]
  // 历史订单列表labels
export let historyOrderLabels = [{
      label: '订单号',
      value: 'orderNumber'
    },
    {
      label: '商品名称',
      value: 'goods[0].name'
    },
    {
      label: '订单时间',
      value: 'created_date'
    },
    {
      label: '订单状态',
      value: 'order_status'
    },
    {
      label: '商品类型',
      value: 'goods_type'
    },
    {
      label: '订单金额',
      value: 'totalAmount'
    },
    {
      label: '订单类型',
      value: 'orederType'
    },
    {
      label: "结算公司",
      value: "goods[0].vendorInfo.balanceOrgName"
    },
    {
      label: '更新时间',
      value: 'lastModifiedDate'
    }
    //   {
    //     label: '业绩归属',
    //     value: ''
    //   }
  ]
  // 健康档案table的labels
export let healthRecordLabels = [{
    label: '类型',
    value: 'record_type'
  },
  {
    label: '记录时间',
    value: 'created_date'
  },
  {
    label: '证件类型',
    value: 'idCardType'
  },
  {
    label: '证件号码',
    value: 'identityCard'
  }
]
export let integralRecordLabels = [{
    label: '记录内容',
    value: 'content'
  },
  {
    label: '记录类型',
    value: 'recordTypeName'
  },
  {
    label: '积分变动',
    value: 'changeValue'
  },
  {
    label: '时间',
    value: 'changeDate'
  },
  {
    label: '备注',
    value: 'remarks'
  }
]
export let exchangeRecordLabels = [{
      label: '兑换商品名称',
      value: 'name'
    },
    {
      label: '使用积分',
      value: 'pay_real'
    },
    {
      label: '兑换时间',
      value: 'created_date'
    },
    {
      label: '订单状态',
      value: 'order_status'
    },
    {
      label: '备注',
      value: 'remark'
    }
  ]
  // 里程碑table的labels
export let milestoneLabels = [{
    label: '时间',
    value: 'milestone_time'
  },
  {
    label: '里程碑内容',
    value: 'content'
  },
  {
    label: '类型',
    value: 'milestone_type'
  }
  //   {
  //     label: '参与形式',
  //     value: ''
  //   }
]
export let invitedCustomerLabels = [{
      label: '姓名',
      value: 'fullName'
    },
    {
      label: '性别',
      value: 'gender'
    },
    {
      label: '生日',
      value: 'birthday_date'
    },
    {
      label: '手机号',
      value: 'mobile'
    },
    //   {
    //     label: '用户名',
    //     value: 'nickname'
    //   },
    {
      label: '邀请时间',
      value: 'invited_time'
    }
  ]
  // 用户收货人地址列表Label
export let shippingAddressLabel = [{
      label: '收货人',
      value: 'contactName'
    },
    {
      label: '手机号码',
      value: 'phone'
    },
    {
      label: '地址',
      value: 'address',
      minWidth: 120
    },
    {
      label: '备注',
      value: 'remarks'
    }
  ]
  // 交易记录table表头
export let recordTableLabels = [{
    label: '交易编号',
    value: 'accountDetail.serialNumber'
  },
  {
    label: '操作类别',
    value: 'accountDetail.business_type'
  },
  {
    label: '交易金额（元）',
    value: 'accountDetail.withdraw_amount'
  },
  {
    label: '收款账户',
    value: 'withdrawalsLog.card_number'
  },
  {
    label: '交易时间',
    value: 'accountDetail.transaction_date',
    minWidth: 120
  }
]
export let inviteCustomerTab = [{
    label: '已邀请用户(0人)',
    value: 'customer'
  },
  {
    label: '已确定家人(0人)',
    value: 'family'
  },
  {
    label: '脐荐康 (0人)',
    value: 'oldBringNew'
  }
]
export let inviteFamilyTableLabels = [{
    label: '姓名',
    value: 'userName'
  },
  {
    label: '称谓',
    value: 'nickName'
  },
  {
    label: '性别',
    value: 'sex'
  },
  {
    label: '生日',
    value: 'birth_day'
  },
  {
    label: '手机号',
    value: 'mobile'
  },
  {
    label: 'CPS合同号',
    value: 'cpsContractNumber'
  },
  {
    label: '邀请时间',
    value: 'invitation_day'
  }
]
export let inviteOldBringNewTableLabels = [{
    label: '姓名',
    value: 'newCustomer.userName'
  },
  {
    label: '性别',
    value: 'sex'
  },
  {
    label: '生日',
    value: 'birth_day'
  },
  {
    label: '手机号',
    value: 'newCustomer.userMobile'
  },
  {
    label: 'CPS合同号',
    value: 'newCustomer.cpsContractCode'
  },
  {
    label: '邀请时间',
    value: 'created_date'
  }
]
export let couponStateTabs = [{
    label: '全部优惠劵',
    value: 'ALL'
  },
  {
    label: '已领取',
    value: 'GOT'
  },
  {
    label: '已使用',
    value: 'USED'
  },
  {
    label: '已失效',
    value: 'INVALID'
  }
]
export let customerCouponTableLabels = [{
    label: '优惠劵名称',
    value: 'title'
  },
  {
    label: '优惠形式',
    value: 'discount_type'
  }
]
export let lifeBankSampleTableLabels = [{
    label: '条码号',
    value: 'mallSample.sampleId'
  },
  {
    label: '样本类型',
    value: 'sampleType'
  },
  {
    label: '子类型',
    value: 'sampleSubType'
  },
  {
    label: '创建时间',
    value: 'createdDate'
  },
  {
    label: '报告状态',
    value: 'is_visible'
  },
  {
    label: 'C端是否可见',
    value: 'isVisibleSample'
  },
  {
    label: '名称',
    value: 'mallSample.sampleName'
  }
]
export let operateOrderTableLables = [{
    label: '母亲姓名',
    value: 'motherName'
  },
  {
    label: '合同号',
    value: 'contractCode',
    minWidth: 123
  },
  {
    label: '母亲手机号',
    value: 'motherMobile',
    minWidth: 110
  },
  {
    label: '母亲身份证',
    value: 'motherCardId',
    minWidth: 122
  },
  {
    label: '组织名称',
    value: 'orgName',
    minWidth: 150
  },
  {
    label: "结算公司",
    value: "balanceOrg"
  }
]
export let integralFilterLabels = [{
    label: '任务名称',
    type: 'select',
    value: 'pointsTaskId',
    clearable: true,
    options: []
  },
  {
    label: '记录类型',
    type: 'select',
    value: 'recordType',
    clearable: true,
    options: [{
        label: '兑换',
        value: 'EXCHANGE'
      },
      {
        label: '退还',
        value: 'RETURN'
      },
      {
        label: '奖励',
        value: 'REWARD'
      },
      {
        label: '撤销',
        value: 'REVOKE'
      }
    ]
  }
]
export let cpsOrederStatus = {
  '0': '无',
  '00': '空',
  '1': '保存',
  '10': '终止',
  '11': '无评价信息',
  '12': '不保存',
  '13': '未知',
  '2': '个例保存',
  '3': '废弃',
  '4': '其他',
  '5': '协议保存',
  '6': '协议废弃',
  '7': '不合格征询意见',
  '8': '合格保存',
  '9': '不合格废弃'
}
export let customerInvoiceTableLabels = [{
    value: "changeDate",
    label: "开票时间"
  },
  {
    value: "contractCode",
    label: "合同号"
  },
  {
    value: "productName",
    label: "产品名称"
  },
  {
    value: "proBarcode",
    label: "条码号"
  }
]